export {
  auth,
  logout,
  authCheckState,
  reg,
  cleanError,
  authUpdateProfileInfo,
  toggleMenuStatus
} from './auth';

export * from './users';
export * from './bars';
export * from './roles';
export * from './devices';
export * from './orders';
export * from './categories';
export * from './menuItems';
export * from './discounts';
export * from './statistics';



// WEBPACK FOOTER //
// ./src/store/actions/index.js